export interface FormsTheme {
  buttonsSpacing: any;
  formGroupLabelColor: any;
}

export default {
  buttonsSpacing: '1rem',
  formGroupLabelColor: ({ theme }: any) => theme.colors.grayDark,
} as FormsTheme;
